import { useState, useEffect } from 'react';
import { breakpoints } from '../theme/tokens/breakpoints';

/**
 * Returns true when viewport width is below the `md` breakpoint (768px).
 * Uses matchMedia for efficient, event-driven updates.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${breakpoints.md - 1}px)`).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoints.md - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
